// 📁 src/utils/dropdownOptions.js
import { getAllCoursesNoPaging } from "../api/elearning/courses/courses";

/**
 * Trả về danh sách khóa học dạng option { value, label }
 * @returns {Promise<Array<{value: string, label: string}>>}
 */

// Hàm trả về danh sách khóa học
// is_active=true
export const getCourseOptions = async () => {
  try {
    const courses = await getAllCoursesNoPaging();
    return courses.map((course) => ({
      value: course.id,
      label: `${course.code} - ${course.name}`,
    }));
  } catch (error) {
    console.error("Lỗi khi tải danh sách khóa học:", error);
    return [];
  }
};

// Hàm trả về danh sách trình độ mặc định
export const getLevelOptions = () => [
  { value: "lop-1", label: "Lớp 1" },
  { value: "lop-2", label: "Lớp 2" },
  { value: "lop-3", label: "Lớp 3" },
  { value: "lop-4", label: "Lớp 4" },
  { value: "lop-5", label: "Lớp 5" },
  { value: "lop-6", label: "Lớp 6" },
  { value: "lop-7", label: "Lớp 7" },
  { value: "lop-8", label: "Lớp 8" },
  { value: "lop-9", label: "Lớp 9" },
  { value: "lop-10", label: "Lớp 10" },
  { value: "lop-11", label: "Lớp 11" },
  { value: "lop-12", label: "Lớp 12" },
  { value: "beginner", label: "Sơ cấp" },
  { value: "intermediate", label: "Trung cấp" },
  { value: "advanced", label: "Nâng cao" },
];

